import { ListItemButton, ListItemButtonProps, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

interface IProps extends ListItemButtonProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

const ListOption = ({ children, sx, ...props }: IProps) => {
  return (
    <ListItemButton sx={{ padding: 0, ...sx }} {...props}>
      {children}
    </ListItemButton>
  );
};

export default ListOption;
